const initCalculationGroup = () => {
    const groupQuestions = document.querySelectorAll('.js-question-form-calculation-group-question');
    const groupTotalField = document.querySelector('.js-question-form-calculation-group-total');

    if (!groupQuestions || !groupTotalField) {
        return;
    }

    const calculateTotal = () => {
        let total = 0;

        for (const question of groupQuestions) {
            const numberField = question.querySelector('.js-question-form-calculation-group-number');
            if (numberField && numberField.value) {
                total += parseFloat(numberField.value) || 0;
            }
        }

        groupTotalField.value = total;
    };

    const disableCommas = event => {
        if (event.key === ',') {
            event.preventDefault();
        }
    };

    for (const question of groupQuestions) {
        const numberField = question.querySelector('.js-question-form-calculation-group-number');

        if (!numberField) {
            return;
        }

        numberField.addEventListener('change', calculateTotal);
        numberField.addEventListener('keydown', disableCommas);
    }
};

document.addEventListener('DOMContentLoaded', function () {
    initCalculationGroup();
});
